import { HttpStatus, IApiResponseMap, IGenericApiError } from "src/services/client";
import { Service } from "src/services/service";

import { ILibraryEntryBase } from "./types/library-entry-base";

export interface ILibraryHtmlPageRead extends ILibraryEntryBase {
    content: string;
}
export interface ILibraryHtmlPageCreate
    extends Pick<ILibraryHtmlPageRead, "title" | "category" | "content" | "isPublic"> {
    tags?: string[];
}
export type ILibraryHtmlPageUpdate = Partial<ILibraryHtmlPageCreate>;

export class LibraryHtmlPageService extends Service {
    public create(data: ILibraryHtmlPageCreate) {
        if (data.tags?.length === 0) {
            delete data.tags;
        }

        const url = this.client.url(["api", "v1", "library-html-pages"]);
        return this.client.post<
            IApiResponseMap<{
                [HttpStatus.Created]: ILibraryHtmlPageRead;
                [HttpStatus.BadRequest]: ValidationError<ILibraryHtmlPageCreate>;
                [HttpStatus.Forbidden]: IGenericApiError;
            }>
        >(url, data);
    }

    public update(uuid: string, data: ILibraryHtmlPageUpdate) {
        const url = this.client.url(["api", "v1", "library-html-pages", uuid]);
        return this.client.patch<
            IApiResponseMap<{
                [HttpStatus.Ok]: ILibraryHtmlPageRead;
                [HttpStatus.BadRequest]: ValidationError<ILibraryHtmlPageUpdate>;
                [HttpStatus.Forbidden]: IGenericApiError;
                [HttpStatus.NotFound]: IGenericApiError;
            }>
        >(url, data);
    }

    public delete(uuid: string) {
        const url = this.client.url(["api", "v1", "library-html-pages", uuid]);
        return this.client.delete<
            IApiResponseMap<{
                [HttpStatus.NoContent]: void;
                [HttpStatus.Forbidden]: IGenericApiError;
                [HttpStatus.NotFound]: IGenericApiError;
            }>
        >(url);
    }
}
